import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import React, { useEffect } from 'react';

import { useElementVisibility } from 'src/shared/hooks/useElementVisiblity';

interface VisibilityPixelProps extends BoxProps {
  onVisibleHandler: () => void;
}

const VisibilityPixel = ({
  onVisibleHandler,
  ...props
}: VisibilityPixelProps) => {
  const [ref, isVisible] = useElementVisibility();

  useEffect(() => {
    if (isVisible) {
      onVisibleHandler();
    }
  }, [isVisible, onVisibleHandler]);

  return (
    <Box
      key="visibility-pixel"
      position="absolute"
      ref={ref}
      testId="visibility-pixel"
      {...props}
    >
      &nbsp;
    </Box>
  );
};

export { VisibilityPixel };
